export const environment = {
  production: true,
  tileURL: 'https://mood-tiles.avia-gis.com/mapproxy/tiles/[[LAYER]]/EPSG3857/{z}/{x}/{y}.png',
  appVersion: "0.0.76-20240904-0715",
};
